import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import "./Portfolio.css";
import "./PortfolioWork.css";

// 🔗 PLACEHOLDER: Add all your portfolio projects here (including the ones from main portfolio + new ones)
const ALL_PORTFOLIO_ITEMS = [
  // Original items from main portfolio
  {
    id: 1,
    title: "GLAMJAM Business Application Design",
    category: "Application Design",
    image: "/images/pproject1.jpeg",
    href: "https://www.behance.net/gallery/175943047/Freelance-App-UI-UX-Design",
  },
  {
    id: 2,
    title: "Product Design",
    category: "Application Design",
    image: "/images/pproject2.jpeg",
    href: "https://www.behance.net/gallery/212675345/Application-Design",
  },
  {
    id: 3,
    title: "MayaOptics E-Commerce Store",
    category: "E-commerce",
    image: "/images/pproject3.jpeg",
    href: "https://www.behance.net/gallery/234849437/Ecommerce-Eye-wear-brands-Landing-Design-For-Shopify",
  },
  {
    id: 4,
    title: "Portfolio Website Design",
    category: "Website Design",
    image: "/images/pproject4.jpeg",
    href: "https://www.behance.net/gallery/213962349/Portfolio-Page-Design",
  },
  {
    id: 5,
    title: "Nescafe Chill Marketing Video",
    category: "Animation Video",
    image: "/images/pproject5.png",
    href: "https://www.behance.net/gallery/220473141/Nescafe-Chill-Marketing-Ads",
  },
  {
    id: 6,
    title: "2D Explainer Animation",
    category: "Animation Video",
    image: "/images/pproject6.png",
    href: "https://www.behance.net/gallery/208894949/2D-Explainer-Animation",
  },

  // Additional projects
  {
    id: 7,
    title: "Jewellery Brand Website Design",
    category: "E-commerce",
    image: "/images/project7.jpg",
    href: "https://www.behance.net/gallery/231604821/jewellery-Brand-Website-Design",
  },
  {
    id: 8,
    title: "Shopify Store Design",
    category: "E-commerce",
    image: "/images/project8.jpg",
    href: "https://www.behance.net/gallery/234849605/Shopify-Store-Design",
  },
  {
    id: 9,
    title: "Ecommerce Website Design",
    category: "E-commerce",
    image: "/images/project9.jpg",
    href: "https://www.behance.net/gallery/238614575/Ecommerce-Website-Design",
  },
  {
    id: 10,
    title: "RoadSphere Website Landing Page",
    category: "Website Design",
    image: "/images/project10.jpg",
    href: "https://www.behance.net/gallery/217135019/RoadSphere-Website-Landing-page",
  },
  {
    id: 11,
    title: "Bees better Landing page Design",
    category: "Website Design",
    image: "/images/project11.jpg",
    href: "https://www.behance.net/gallery/216210421/Bees-better-Landing-page-Design",
  },
  {
    id: 12,
    title: "Non Profit Welfare landing page",
    category: "Website Design",
    image: "/images/project12.jpg",
    href: "https://www.behance.net/gallery/229356877/Non-Profit-Welfare-landing-page",
  },
  {
    id: 13,
    title: "URBAN Website Design",
    category: "E-commerce",
    image: "/images/project13.jpg",
    href: "https://www.behance.net/gallery/211546203/Website-Design",
  },
  {
    id: 14,
    title: "Create My sign Website Design",
    category: "Website Design",
    image: "/images/project14.jpg",
    href: "https://www.behance.net/gallery/220527437/Website-Design",
  },
  {
    id: 15,
    title: "Landing page Design For PPC",
    category: "Website Design",
    image: "/images/project15.jpg",
    href: "https://www.behance.net/gallery/218053453/Landing-page-Design-For-PPC",
  },
  {
    id: 16,
    title: "Pawfurr Website Design",
    category: "Website Design",
    image: "/images/project16.jpg",
    href: "https://www.behance.net/gallery/218053275/Website-Design",
  },
  {
    id: 17,
    title: "Logic works Landing page Design",
    category: "Website Design",
    image: "/images/project17.jpg",
    href: "https://www.behance.net/gallery/208073079/Logic-works-Landing-page-Design",
  },
  {
    id: 18,
    title: "Weekly Bizz Blog Landing page Design",
    category: "Website Design",
    image: "/images/project18.jpg",
    href: "https://www.behance.net/gallery/209708033/Weekly-BIzz-Landing-Page-Design",
  },
  {
    id: 19,
    title: "Charred Candle Ecommerce Website Design",
    category: "E-commerce",
    image: "/images/project19.jpg",
    href: "https://www.behance.net/gallery/210550059/Charred-Candle-Ecommerce-Website-Design",
  },
  {
    id: 20,
    title: "2D Animation Landing page",
    category: "Website Design",
    image: "/images/project20.png",
    href: "https://www.behance.net/gallery/238702069/2D-Animation-Landing-page",
  },
  {
    id: 21,
    title: "Womagazine Website Design",
    category: "Website Design",
    image: "/images/project21.jpg",
    href: "https://www.figma.com/proto/rLYX0wgnPH0YSIRFgw43CV/womagzine-Landing-page?node-id=306-118&t=WsTRRMXFUZgL3AG9-1&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1",
  },
  { 
    id: 22, 
    title: 'Atadk Vehicle Parts Store Design', 
    category: 'E-commerce', 
    image: '/images/project1.jpeg', 
    href: 'https://www.figma.com/proto/XiEnR1ot4Q7v2zILg0AxWI/atadk-Dark-mode?node-id=1035-2415&t=zbwFZriw7rOebu4o-1&scaling=min-zoom&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=790%3A3503' 
  },
  { 
    id: 23, 
    title: 'Ai Marketinglabz Website Design', 
    category: 'Website Design', 
    image: '/images/project2.jpeg', 
    href: 'https://www.figma.com/proto/1MKh3CikjvKdDV8D4C7EYh/Ai-Marketing-labz?node-id=1-2&t=YH15kS57hVEWHU5U-1' 
  },
  { 
    id: 24, 
    title: 'Prettinpink Promo', 
    category: 'Marketing Video', 
    image: '/images/project24.png', 
    href: 'https://www.behance.net/gallery/206980965/Prettinpink-promo' 
  },
  { 
    id: 25, 
    title: 'Marketing Ads', 
    category: 'Marketing Video', 
    image: '/images/project25.jpg', 
    href: 'https://www.behance.net/gallery/220471105/Marketing-Ads' 
  },
  { 
    id: 26, 
    title: 'Lifebuoy Germ Buster Game Marketing Video', 
    category: 'Marketing Video', 
    image: '/images/project26.jpg', 
    href: 'https://www.behance.net/gallery/220248353/Lifebuoy-Germ-Buster-Game-Marketing-Video' 
  },
  { 
    id: 27, 
    title: 'Pepsi AI Powered Video', 
    category: 'Animation Video', 
    image: '/images/project27.png', 
    href: 'https://www.behance.net/gallery/222291735/Pepsi-AI-powered-video' 
  },
  { 
    id: 28, 
    title: 'Explainer Video', 
    category: 'Animation Video', 
    image: '/images/project28.jpg', 
    href: 'https://www.behance.net/gallery/229355763/Explainer-Video-For' 
  },
  { 
    id: 29, 
    title: 'Explainer Video For Liberty Web Studio', 
    category: 'Animation Video', 
    image: '/images/project29.jpg', 
    href: 'https://www.behance.net/gallery/218886879/Explainer-Video-For-Liberty-Web-Studio' 
  },
  { 
    id: 30, 
    title: 'No Filter Graphics LLC', 
    category: 'Marketing Video', 
    image: '/images/project30.png', 
    href: 'https://www.behance.net/gallery/207180427/No-Filter-Graphics-LLC' 
  },
  { 
    id: 31, 
    title: 'Dazzle Detailing', 
    category: 'Marketing Video', 
    image: '/images/project31.jpg', 
    href: 'https://www.behance.net/gallery/206707251/Web-site-Banner' 
  },
  { 
    id: 32, 
    title: 'Daily Check In', 
    category: 'Animation Video', 
    image: '/images/project32.png', 
    href: 'https://www.behance.net/gallery/206715111/Daily-Check-In' 
  },
   { 
    id: 33, 
    title: 'Logo Designs', 
    category: 'Logo Design', 
    image: '/images/project33.jpeg', 
    href: 'https://www.behance.net/gallery/225121209/Logo-Designs-for-Fiverr-Clients-2025-Showcase' 
  },{
    id: 34,
    title: 'CheckMyStaff Mobile App Design',
    category: "Application Design",
    image: '/images/project3.jpeg',
    href: 'https://www.figma.com/proto/DciBReVGHMumgdf54XQGHr/CheckMyStaff-Mobile-App?node-id=331-5378&t=0GH7iNuPE4YQQhkV-1&scaling=scale-down&content-scaling=fixed&page-id=1%3A5&starting-point-node-id=216%3A4353',
  }
];

// Get unique categories from ALL_PORTFOLIO_ITEMS
const categories = [
  "All",
  ...new Set(ALL_PORTFOLIO_ITEMS.map((item) => item.category)),
];

export default function PortfolioWork() {
  const location = useLocation();
  const [activeCategory, setActiveCategory] = useState("All");

  // Check if we have a category from navigation
  useEffect(() => {
    if (location.state?.selectedCategory) {
      setActiveCategory(location.state.selectedCategory);
      
      // Scroll to portfolio section smoothly
      const portfolioSection = document.getElementById('portfolio-work');
      if (portfolioSection) {
        setTimeout(() => {
          portfolioSection.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
      
      // Clear the state so it doesn't persist on refresh
      window.history.replaceState({}, document.title);
    }
  }, [location]);

  // Filter items based on active category
  const filteredItems =
    activeCategory === "All"
      ? ALL_PORTFOLIO_ITEMS
      : ALL_PORTFOLIO_ITEMS.filter((item) => item.category === activeCategory);

  return (
    <section className="portfolio-work section" id="portfolio-work">
      <div className="container">
        <div className="text-center">
          <span className="section-label">My Portfolio</span>
          <h2 className="section-title">All Projects</h2>
          <div className="divider" />
          <p className="section-description">
            Explore my complete collection of design and animation work
          </p>
        </div>

        {/* Category Filter Buttons */}
        <div className="portfolio-categories">
          {categories.map((category) => (
            <button
              key={category}
              className={`category-btn ${activeCategory === category ? "active" : ""}`}
              onClick={() => setActiveCategory(category)}
            >
              {category}
            </button>
          ))}
        </div>

        <div className="portfolio-grid">
          {filteredItems.map((item) => (
            <a
              href={item.href}
              className="portfolio-item"
              key={item.id}
              target="_blank"
              rel="noopener noreferrer"
            >
              <div className="portfolio-thumb">
                {item.image ? (
                  <img src={item.image} alt={item.title} />
                ) : (
                  <div className="portfolio-placeholder">
                    <span>+</span>
                  </div>
                )}
                <div className="portfolio-hover">
                  <span className="portfolio-item-category">
                    {item.category}
                  </span>
                  <h4 className="portfolio-item-title">{item.title}</h4>
                </div>
              </div>
            </a>
          ))}
        </div>

        {/* Back to Home Button */}
        <div className="text-center" style={{ marginTop: "40px" }}>
          <a
            href="https://www.behance.net/faheem_graphics"
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary"
          >
            View Behance Profile
          </a>
        </div>
      </div>
    </section>
  );
}